import React, { useMemo } from "react";
import FormFieldVisibilitySettings from "./FormFieldVisibilitySettings";
import { fetchCustomerDynamicForm } from "../Master/Customers/customerDynamicFormApi";
import {
  applyCustomerPriorityFieldDefaults,
  CUSTOMER_CREDIT_DEPENDENT_FIELDS,
  CUSTOMER_PRIORITY_FIELD_ORDER,
  CUSTOMER_RED_FIELD_NAMES,
  mapDefaultCustomerFieldRows,
  resolveCustomerSettingsFieldName,
} from "./customerFormFieldDefaults";

export default function CustomerFormFieldSettings() {
  const defaultFields = useMemo(
    () =>
      applyCustomerPriorityFieldDefaults(mapDefaultCustomerFieldRows()),
    [],
  );

  return (
    <FormFieldVisibilitySettings
      title="Customer Form Fields"
      formKey="add_customer"
      module="customer"
      fetchForm={fetchCustomerDynamicForm}
      saveEndpoint="/update_dynamic_form_customer"
      defaultFields={defaultFields}
      resolveFieldName={resolveCustomerSettingsFieldName}
      normalizeRows={applyCustomerPriorityFieldDefaults}
      lockedFieldNames={CUSTOMER_PRIORITY_FIELD_ORDER}
      highlightFieldNames={CUSTOMER_RED_FIELD_NAMES}
      splitColumns={2}
      linkedFieldGroups={[
        {
          parent: "credit_facility",
          children: CUSTOMER_CREDIT_DEPENDENT_FIELDS,
        },
      ]}
    />
  );
}
